import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  Text,
  IconTelephone,
  IconMail,
  IconLocation,
  Space,
} from '@redlink/components/atoms';

export const ContactInfoItems = memo(
  ({
    style,
    data: { cellphoneNumber = '', emailAddress = '', address = '' } = {},
    iconColor,
    panel,
  }) => {
    const { styles } = useStyle();
    return (
      <View style={[styles.container, style]}>
        {cellphoneNumber && (
          <ContactItem
            icon={<IconTelephone color={iconColor} />}
            title={cellphoneNumber}
            {...{ panel }}
          />
        )}
        {emailAddress && (
          <ContactItem
            icon={<IconMail color={iconColor} />}
            title={emailAddress}
            {...{ panel }}
          />
        )}
        {address && (
          <ContactItem
            icon={<IconLocation color={iconColor} />}
            title={address}
            {...{ panel }}
          />
        )}
      </View>
    );
  }
);

const ContactItem = memo(({ title, icon, panel }) => {
  const { styles } = useStyle();
  return (
    <View style={styles.itemContainer}>
      {icon}
      <Text style={[styles.text, panel && styles.textPanel]}>{title}</Text>
    </View>
  );
});

const useStyle = createUseStyle(({ colors }) => ({
  container: {},
  itemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 8,
  },
  text: {
    lineHeight: 20,
    paddingStart: 8,
    fontSize: 14,
    color: colors.subtitle,
  },
  textPanel: {
    color: colors.gray23,
  },
}));
